<main style="background: #ffffff">
  <div
    class="py-5 style_bg_img row align-items-center"
    style="background-image: url(&quot;assets/img/carte_bar_dark.png&quot;); min-height: 100vh"
  >
    <div class="col-sm-8 col-lg-5 mx-auto my-5 text-center">
      <div class="mb-3">
        <h1 class="display-1"><i class="bi-emoji-frown"></i></h1>
        <h1 class="display-1 mb-0 text-primary style_bolder">404</h1>
        <h2 class="text-primary">Page non trouvée</h2>
        <div class="text-center">
          <a routerLink="/" class="style_link">Retour</a>
          <!-- <a [href]="url" target="_blank" class="style_link mx-2">A</a> -->
        </div>
      </div>
    </div>
  </div>
</main>
